import { reject } from 'bluebird';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, OverlayTrigger, Panel, Table, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { SET_APP_CONFIG } from 'actions/const';

import { IS_VALID } from 'utils';

import saveTrail from '../../utils/saveTrail';
import FormContainer from './FormContainer';
import {
	CARD_BOOL_KEYS,
	EVOUCHER_NOTIF_NUM_KEYS,
	GENERIC_STRING_KEYS,
	MENU_BOOL_KEYS,
	SHOWS_NOTIF_NUM_KEYS,
} from './keys';

const zeroPad = (num, places) => String(num).padStart(places, '0');

class AppConfig extends Component {
	constructor(props) {
		super(props);

		this.getEVoucherNotifConfig = this.getEVoucherNotifConfig.bind(this);
		this.saveEVoucherNotifConfig = this.saveEVoucherNotifConfig.bind(this);
		this.getShowsNotifConfig = this.getShowsNotifConfig.bind(this);
		this.saveShowsNotifConfig = this.saveShowsNotifConfig.bind(this);
		this.getMenuConfig = this.getMenuConfig.bind(this);
		this.saveMenuConfig = this.saveMenuConfig.bind(this);
		this.getCardConfig = this.getCardConfig.bind(this);
		this.saveCardConfig = this.saveCardConfig.bind(this);
		this.getStringConfig = this.getStringConfig.bind(this);
		this.saveStringConfig = this.saveStringConfig.bind(this);
		this.renderModalButton = this.renderModalButton.bind(this);
	}

	getEVoucherNotifConfig() {
		const { actions } = this.props;

		actions.setValue({
			evoucherNotif_isLoading: true,
		});

		const numberConfigQuery = new Parse.Query('NumberConfig');

		numberConfigQuery.containedIn('name', Object.keys(EVOUCHER_NOTIF_NUM_KEYS));

		numberConfigQuery
			.find()
			.then((data) => {
				const stateToUpdate = {
					evoucherNotif_isLoading: false,
				};

				for (let item of data) {
					if (EVOUCHER_NOTIF_NUM_KEYS[item.get('name')]) {
						stateToUpdate[EVOUCHER_NOTIF_NUM_KEYS[item.get('name')] + '_parseObject'] = item;
						stateToUpdate[EVOUCHER_NOTIF_NUM_KEYS[item.get('name')]] = zeroPad(
							item.get('value') || 0,
							2
						);
					}
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getEVoucherNotifConfig error');
				console.log(err);

				actions.setValue({
					evoucherNotif_isLoading: false,
				});
			});
	}

	async saveEVoucherNotifConfig() {
		const { AppConfig, actions } = this.props;

		let {
			evoucherNotif_dailyNotifAM_hh_parseObject,

			evoucherNotif_dailyNotifAM_mm_parseObject,

			evoucherNotif_dailyNotifPM_hh_parseObject,

			evoucherNotif_dailyNotifPM_mm_parseObject,

			evoucherNotif_dailyAM,
			evoucherNotif_dailyPM,
		} = AppConfig;

		if (!IS_VALID(evoucherNotif_dailyAM)) {
			toast.error('Daily AM is required.');
		} else if (!moment(evoucherNotif_dailyAM, 'HH:mm', true).isValid()) {
			toast.error('Please select a valid Daily AM.');
		} else if (!IS_VALID(evoucherNotif_dailyPM)) {
			toast.error('Daily PM is required.');
		} else if (!moment(evoucherNotif_dailyPM, 'HH:mm', true).isValid()) {
			toast.error('Please select a valid Daily PM.');
		} else {
			actions.setValue({
				isLoadingAction: true,
			});

			try {
				const numberConfigs = await Promise.all([
					new Promise((resolve, reject) => {
						if (evoucherNotif_dailyNotifAM_hh_parseObject) {
							resolve(evoucherNotif_dailyNotifAM_hh_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'DAILY_NOTIF_TIME_AM_HH');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'DAILY_NOTIF_TIME_AM_HH',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
					new Promise((resolve, reject) => {
						if (evoucherNotif_dailyNotifAM_mm_parseObject) {
							resolve(evoucherNotif_dailyNotifAM_mm_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'DAILY_NOTIF_TIME_AM_MM');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'DAILY_NOTIF_TIME_AM_MM',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
					new Promise((resolve, reject) => {
						if (evoucherNotif_dailyNotifPM_hh_parseObject) {
							resolve(evoucherNotif_dailyNotifPM_hh_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'DAILY_NOTIF_TIME_PM_HH');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'DAILY_NOTIF_TIME_PM_HH',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
					new Promise((resolve, reject) => {
						if (evoucherNotif_dailyNotifPM_mm_parseObject) {
							resolve(evoucherNotif_dailyNotifPM_mm_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'DAILY_NOTIF_TIME_PM_MM');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'DAILY_NOTIF_TIME_PM_MM',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
				]);

				evoucherNotif_dailyNotifAM_hh_parseObject = numberConfigs[0];
				evoucherNotif_dailyNotifAM_mm_parseObject = numberConfigs[1];
				evoucherNotif_dailyNotifPM_hh_parseObject = numberConfigs[2];
				evoucherNotif_dailyNotifPM_mm_parseObject = numberConfigs[3];

				evoucherNotif_dailyAM = moment(evoucherNotif_dailyAM, 'HH:mm', true);

				if (
					!IS_VALID(evoucherNotif_dailyNotifAM_hh_parseObject.get('value')) ||
					evoucherNotif_dailyNotifAM_hh_parseObject.get('value') !== evoucherNotif_dailyAM.hour()
				) {
					evoucherNotif_dailyNotifAM_hh_parseObject.set('value', evoucherNotif_dailyAM.hour());
				}

				if (
					!IS_VALID(evoucherNotif_dailyNotifAM_mm_parseObject.get('value')) ||
					evoucherNotif_dailyNotifAM_mm_parseObject.get('value') !== evoucherNotif_dailyAM.minute()
				) {
					evoucherNotif_dailyNotifAM_mm_parseObject.set('value', evoucherNotif_dailyAM.minute());
				}

				evoucherNotif_dailyPM = moment(evoucherNotif_dailyPM, 'HH:mm', true);

				if (
					!IS_VALID(evoucherNotif_dailyNotifPM_hh_parseObject.get('value')) ||
					evoucherNotif_dailyNotifPM_hh_parseObject.get('value') !== evoucherNotif_dailyPM.hour()
				) {
					evoucherNotif_dailyNotifPM_hh_parseObject.set('value', evoucherNotif_dailyPM.hour());
				}

				if (
					!IS_VALID(evoucherNotif_dailyNotifPM_mm_parseObject.get('value')) ||
					evoucherNotif_dailyNotifPM_mm_parseObject.get('value') !== evoucherNotif_dailyPM.minute()
				) {
					evoucherNotif_dailyNotifPM_mm_parseObject.set('value', evoucherNotif_dailyPM.minute());
				}

				let data = await Parse.Object.saveAll([
					evoucherNotif_dailyNotifAM_hh_parseObject,
					evoucherNotif_dailyNotifAM_mm_parseObject,
					evoucherNotif_dailyNotifPM_hh_parseObject,
					evoucherNotif_dailyNotifPM_mm_parseObject,
				]);

				let stateToUpdate = {
					isLoadingAction: false,

					showModal: false,
					evoucherNotif_dailyNotifAM_hh: zeroPad(data[0].get('value'), 2),
					evoucherNotif_dailyNotifAM_hh_parseObject: data[0],

					evoucherNotif_dailyNotifAM_mm: zeroPad(data[1].get('value'), 2),
					evoucherNotif_dailyNotifAM_mm_parseObject: data[1],

					evoucherNotif_dailyNotifPM_hh: zeroPad(data[2].get('value'), 2),
					evoucherNotif_dailyNotifPM_hh_parseObject: data[2],

					evoucherNotif_dailyNotifPM_mm: zeroPad(data[3].get('value'), 2),
					evoucherNotif_dailyNotifPM_mm_parseObject: data[3],
				};

				actions.setValue(stateToUpdate);

				toast.success('Data has been updated.');

				saveTrail('UPDATE', {
					EVOUCHER_NOTIF:
						'(' +
						'Daily AM: ' +
						evoucherNotif_dailyAM.formt('HH:mm') +
						' | Daily PM: ' +
						evoucherNotif_dailyPM.formt('HH:mm') +
						')',
				});
			} catch (error) {
				console.log('saveEVoucherNotifConfig error');
				console.log(error);

				actions.setValue({
					isLoadingAction: false,
				});

				this.getEVoucherNotifConfig();
			}
		}
	}

	getShowsNotifConfig() {
		const { actions } = this.props;

		actions.setValue({
			showsNotif_isLoading: true,
		});

		const numberConfigQuery = new Parse.Query('NumberConfig');

		numberConfigQuery.containedIn('name', Object.keys(SHOWS_NOTIF_NUM_KEYS));

		numberConfigQuery
			.find()
			.then((data) => {
				const stateToUpdate = {
					showsNotif_isLoading: false,
				};

				for (let item of data) {
					if (SHOWS_NOTIF_NUM_KEYS[item.get('name')]) {
						stateToUpdate[SHOWS_NOTIF_NUM_KEYS[item.get('name')] + '_parseObject'] = item;
						stateToUpdate[SHOWS_NOTIF_NUM_KEYS[item.get('name')]] = item.get('value');
					}
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getShowsNotifConfig error');
				console.log(err);

				actions.setValue({
					showsNotif_isLoading: false,
				});
			});
	}

	async saveShowsNotifConfig() {
		const { AppConfig, actions } = this.props;

		let {
			showsNotif_dailyNotif_hh_parseObject,

			showsNotif_dailyNotif_mm_parseObject,

			showsNotif_dailyNotif_ss_parseObject,

			showsNotif_form_dailyNotif_hh,
			showsNotif_form_dailyNotif_mm,
			showsNotif_form_dailyNotif_ss,
		} = AppConfig;

		showsNotif_form_dailyNotif_hh = parseInt(showsNotif_form_dailyNotif_hh) || 0;
		showsNotif_form_dailyNotif_mm = parseInt(showsNotif_form_dailyNotif_mm) || 0;
		showsNotif_form_dailyNotif_ss = parseInt(showsNotif_form_dailyNotif_ss) || 0;

		if (IS_VALID(showsNotif_form_dailyNotif_hh) && showsNotif_form_dailyNotif_hh < 0) {
			toast.error('Hour should not be less than zero.');
		} else if (IS_VALID(showsNotif_form_dailyNotif_mm) && showsNotif_form_dailyNotif_mm < 0) {
			toast.error('Minute should not be less than zero.');
		} else if (IS_VALID(showsNotif_form_dailyNotif_ss) && showsNotif_form_dailyNotif_ss < 0) {
			toast.error('Second should not be less than zero.');
		} else {
			actions.setValue({
				isLoadingAction: true,
			});

			try {
				const numberConfigs = await Promise.all([
					new Promise((resolve, reject) => {
						if (showsNotif_dailyNotif_hh_parseObject) {
							resolve(showsNotif_dailyNotif_hh_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'SHOWS_DAILY_NOTIF_TIME_HH');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'SHOWS_DAILY_NOTIF_TIME_HH',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
					new Promise((resolve, reject) => {
						if (showsNotif_dailyNotif_mm_parseObject) {
							resolve(showsNotif_dailyNotif_mm_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'SHOWS_DAILY_NOTIF_TIME_MM');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'SHOWS_DAILY_NOTIF_TIME_MM',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
					new Promise((resolve, reject) => {
						if (showsNotif_dailyNotif_ss_parseObject) {
							resolve(showsNotif_dailyNotif_ss_parseObject);
						} else {
							let numberConfigQuery = new Parse.Query('NumberConfig');

							numberConfigQuery.equalTo('name', 'SHOWS_DAILY_NOTIF_TIME_SS');

							numberConfigQuery
								.first()
								.then((data) => {
									if (!data) {
										resolve(
											new Parse.Object('NumberConfig', {
												name: 'SHOWS_DAILY_NOTIF_TIME_SS',
											})
										);
									} else {
										resolve(data);
									}
								})
								.catch(reject);
						}
					}),
				]);

				showsNotif_dailyNotif_hh_parseObject = numberConfigs[0];
				showsNotif_dailyNotif_mm_parseObject = numberConfigs[1];
				showsNotif_dailyNotif_ss_parseObject = numberConfigs[2];

				if (
					!IS_VALID(showsNotif_dailyNotif_hh_parseObject.get('value')) ||
					showsNotif_dailyNotif_hh_parseObject.get('value') !== showsNotif_form_dailyNotif_hh
				) {
					showsNotif_dailyNotif_hh_parseObject.set('value', showsNotif_form_dailyNotif_hh);
				}

				if (
					!IS_VALID(showsNotif_dailyNotif_mm_parseObject.get('value')) ||
					showsNotif_dailyNotif_mm_parseObject.get('value') !== showsNotif_form_dailyNotif_mm
				) {
					showsNotif_dailyNotif_mm_parseObject.set('value', showsNotif_form_dailyNotif_mm);
				}

				if (
					!IS_VALID(showsNotif_dailyNotif_ss_parseObject.get('value')) ||
					showsNotif_dailyNotif_ss_parseObject.get('value') !== showsNotif_form_dailyNotif_ss
				) {
					showsNotif_dailyNotif_ss_parseObject.set('value', showsNotif_form_dailyNotif_ss);
				}

				let data = await Parse.Object.saveAll([
					showsNotif_dailyNotif_hh_parseObject,
					showsNotif_dailyNotif_mm_parseObject,
					showsNotif_dailyNotif_ss_parseObject,
				]);

				let stateToUpdate = {
					isLoadingAction: false,

					showModal: false,
					showsNotif_dailyNotif_hh: data[0].get('value'),
					showsNotif_dailyNotif_hh_parseObject: data[0],

					showsNotif_dailyNotif_mm: data[1].get('value'),
					showsNotif_dailyNotif_mm_parseObject: data[1],

					showsNotif_dailyNotif_ss: data[2].get('value'),
					showsNotif_dailyNotif_ss_parseObject: data[2],
				};

				actions.setValue(stateToUpdate);

				toast.success('Data has been updated.');

				saveTrail('UPDATE', {
					SHOWS_NOTIF:
						'(' +
						'Hour: ' +
						showsNotif_form_dailyNotif_hh +
						' | Minute: ' +
						showsNotif_form_dailyNotif_mm +
						' | Second: ' +
						showsNotif_form_dailyNotif_ss +
						')',
				});
			} catch (error) {
				console.log('saveShowsNotifConfig error');
				console.log(error);

				actions.setValue({
					isLoadingAction: false,
				});

				this.getShowsNotifConfig();
			}
		}
	}

	getMenuConfig() {
		const { actions } = this.props;

		actions.setValue({
			menu_isLoading: true,
		});

		const booleanConfigQuery = new Parse.Query('BooleanConfig');

		booleanConfigQuery.containedIn('name', Object.keys(MENU_BOOL_KEYS));

		booleanConfigQuery
			.find()
			.then((data) => {
				const stateToUpdate = {
					menu_isLoading: false,
				};

				for (let item of data) {
					if (MENU_BOOL_KEYS[item.get('name')]) {
						stateToUpdate[MENU_BOOL_KEYS[item.get('name')] + '_parseObject'] = item;
						stateToUpdate[MENU_BOOL_KEYS[item.get('name')]] = item.get('value') || false;
					}
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getMenuConfig error');
				console.log(err);

				actions.setValue({
					menu_isLoading: false,
				});
			});
	}

	async saveMenuConfig() {
		const { AppConfig, actions } = this.props;

		let {
			menu_isTierPointsEnabled_parseObject,

			menu_form_isTierPointsEnabled,

			menu_isGVEnabled_parseObject,

			menu_form_isGVEnabled,

			menu_isCalypsoEnabled_parseObject,

			menu_form_isCalypsoEnabled,

			menu_isRaffleDrawEnabled_parseObject,
			menu_form_isRaffleDrawEnabled,

			menu_isInvitationsEnabled_parseObject,
			menu_form_isInvitationsEnabled,
		} = AppConfig;

		actions.setValue({
			isLoadingAction: true,
		});

		try {
			const booleanConfigs = await Promise.all([
				new Promise((resolve, reject) => {
					if (menu_isTierPointsEnabled_parseObject) {
						resolve(menu_isTierPointsEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'MENU_TIER_POINTS_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'MENU_TIER_POINTS_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
				new Promise((resolve, reject) => {
					if (menu_isGVEnabled_parseObject) {
						resolve(menu_isGVEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'MENU_GV_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'MENU_GV_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
				new Promise((resolve, reject) => {
					if (menu_isCalypsoEnabled_parseObject) {
						resolve(menu_isCalypsoEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'MENU_CALYPSO_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'MENU_CALYPSO_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
				new Promise((resolve, reject) => {
					if (menu_isRaffleDrawEnabled_parseObject) {
						resolve(menu_isRaffleDrawEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'MENU_RAFFLE_DRAW_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'MENU_RAFFLE_DRAW_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
				new Promise((resolve, reject) => {
					if (menu_isInvitationsEnabled_parseObject) {
						resolve(menu_isInvitationsEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'MENU_INVITATIONS_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'MENU_INVITATIONS_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
			]);

			menu_isTierPointsEnabled_parseObject = booleanConfigs[0];
			menu_isGVEnabled_parseObject = booleanConfigs[1];
			menu_isCalypsoEnabled_parseObject = booleanConfigs[2];
			menu_isRaffleDrawEnabled_parseObject = booleanConfigs[3];
			menu_isInvitationsEnabled_parseObject = booleanConfigs[4];

			if (
				!IS_VALID(menu_isTierPointsEnabled_parseObject.get('value')) ||
				menu_isTierPointsEnabled_parseObject.get('value') !== menu_form_isTierPointsEnabled
			) {
				menu_isTierPointsEnabled_parseObject.set('value', menu_form_isTierPointsEnabled);
			}

			if (
				!IS_VALID(menu_isGVEnabled_parseObject.get('value')) ||
				menu_isGVEnabled_parseObject.get('value') !== menu_form_isGVEnabled
			) {
				menu_isGVEnabled_parseObject.set('value', menu_form_isGVEnabled);
			}

			if (
				!IS_VALID(menu_isCalypsoEnabled_parseObject.get('value')) ||
				menu_isCalypsoEnabled_parseObject.get('value') !== menu_form_isCalypsoEnabled
			) {
				menu_isCalypsoEnabled_parseObject.set('value', menu_form_isCalypsoEnabled);
			}

			if (
				!IS_VALID(menu_isRaffleDrawEnabled_parseObject.get('value')) ||
				menu_isRaffleDrawEnabled_parseObject.get('value') !== menu_form_isRaffleDrawEnabled
			) {
				menu_isRaffleDrawEnabled_parseObject.set('value', menu_form_isRaffleDrawEnabled);
			}

			if (
				!IS_VALID(menu_isInvitationsEnabled_parseObject.get('value')) ||
				menu_isInvitationsEnabled_parseObject.get('value') !== menu_form_isInvitationsEnabled
			) {
				menu_isInvitationsEnabled_parseObject.set('value', menu_form_isInvitationsEnabled);
			}

			let data = await Parse.Object.saveAll([
				menu_isTierPointsEnabled_parseObject,
				menu_isGVEnabled_parseObject,
				menu_isCalypsoEnabled_parseObject,
				menu_isRaffleDrawEnabled_parseObject,
				menu_isInvitationsEnabled_parseObject,
			]);

			let stateToUpdate = {
				isLoadingAction: false,

				showModal: false,
				menu_isTierPointsEnabled: data[0].get('value'),
				menu_isTierPointsEnabled_parseObject: data[0],

				menu_isGVEnabled: data[1].get('value'),
				menu_isGVEnabled_parseObject: data[1],

				menu_isCalypsoEnabled: data[2].get('value'),
				menu_isCalypsoEnabled_parseObject: data[2],

				menu_isRaffleDrawEnabled: data[3].get('value'),
				menu_isRaffleDrawEnabled_parseObject: data[3],

				menu_isInvitationsEnabled: data[4].get('value'),
				menu_isInvitationsEnabled_parseObject: data[4],
			};

			actions.setValue(stateToUpdate);

			toast.success('Data has been updated.');

			saveTrail('UPDATE', {
				MENU:
					'(' +
					'Tier Points: ' +
					(menu_form_isTierPointsEnabled ? 'En' : 'Dis') +
					'abled' +
					'Gift Voucher: ' +
					(menu_form_isGVEnabled ? 'En' : 'Dis') +
					'abled' +
					'Calypso Voucher: ' +
					(menu_form_isCalypsoEnabled ? 'En' : 'Dis') +
					'abled' +
					'Raffle Draw: ' +
					(menu_form_isRaffleDrawEnabled ? 'En' : 'Dis') +
					'abled' +
					'Invitations: ' +
					(menu_form_isInvitationsEnabled ? 'En' : 'Dis') +
					'abled' +
					')',
			});
		} catch (error) {
			console.log('saveMenuConfig error');
			console.log(error);

			actions.setValue({
				isLoadingAction: false,
			});

			this.getMenuConfig();
		}
	}

	getCardConfig() {
		const { actions } = this.props;

		actions.setValue({
			card_isLoading: true,
		});

		const booleanConfigQuery = new Parse.Query('BooleanConfig');

		booleanConfigQuery.containedIn('name', Object.keys(CARD_BOOL_KEYS));

		booleanConfigQuery
			.find()
			.then((data) => {
				const stateToUpdate = {
					card_isLoading: false,
				};

				for (let item of data) {
					if (CARD_BOOL_KEYS[item.get('name')]) {
						stateToUpdate[CARD_BOOL_KEYS[item.get('name')] + '_parseObject'] = item;
						stateToUpdate[CARD_BOOL_KEYS[item.get('name')]] = item.get('value') || false;
					}
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getCardConfig error');
				console.log(err);

				actions.setValue({
					card_isLoading: false,
				});
			});
	}

	async saveCardConfig() {
		const { AppConfig, actions } = this.props;

		let {
			card_isQRCodeEnabled_parseObject,

			card_form_isQRCodeEnabled,
		} = AppConfig;

		actions.setValue({
			isLoadingAction: true,
		});

		try {
			const booleanConfigs = await Promise.all([
				new Promise((resolve, reject) => {
					if (card_isQRCodeEnabled_parseObject) {
						resolve(card_isQRCodeEnabled_parseObject);
					} else {
						let booleanConfigQuery = new Parse.Query('BooleanConfig');

						booleanConfigQuery.equalTo('name', 'CARD_QR_CODE_ENABLED');

						booleanConfigQuery
							.first()
							.then((data) => {
								if (!data) {
									resolve(
										new Parse.Object('BooleanConfig', {
											name: 'CARD_QR_CODE_ENABLED',
										})
									);
								} else {
									resolve(data);
								}
							})
							.catch(reject);
					}
				}),
			]);

			card_isQRCodeEnabled_parseObject = booleanConfigs[0];

			if (
				!IS_VALID(card_isQRCodeEnabled_parseObject.get('value')) ||
				card_isQRCodeEnabled_parseObject.get('value') !== card_form_isQRCodeEnabled
			) {
				card_isQRCodeEnabled_parseObject.set('value', card_form_isQRCodeEnabled);
			}

			let data = await Parse.Object.saveAll([card_isQRCodeEnabled_parseObject]);

			let stateToUpdate = {
				isLoadingAction: false,

				showModal: false,
				card_isQRCodeEnabled: data[0].get('value'),
				card_isQRCodeEnabled_parseObject: data[0],
			};

			actions.setValue(stateToUpdate);

			toast.success('Data has been updated.');

			saveTrail('UPDATE', {
				MENU: '(' + 'QR Code: ' + (card_form_isQRCodeEnabled ? 'En' : 'Dis') + 'abled' + ')',
			});
		} catch (error) {
			console.log('saveCardConfig error');
			console.log(error);

			actions.setValue({
				isLoadingAction: false,
			});

			this.getCardConfig();
		}
	}

	getStringConfig() {
		const { actions } = this.props;

		actions.setValue({
			string_isLoading: true,
		});

		const stringConfigQuery = new Parse.Query('StringConfig');

		stringConfigQuery.containedIn('name', Object.keys(GENERIC_STRING_KEYS));

		stringConfigQuery
			.find()
			.then((data) => {
				const stateToUpdate = {
					string_isLoading: false,
				};

				for (let item of data) {
					if (GENERIC_STRING_KEYS[item.get('name')]) {
						stateToUpdate[GENERIC_STRING_KEYS[item.get('name')] + '_parseObject'] = item;
						stateToUpdate[GENERIC_STRING_KEYS[item.get('name')]] = item.get('value') || '';
					}
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getStringConfig error');
				console.log(err);

				actions.setValue({
					string_isLoading: false,
				});
			});
	}

	async saveStringConfig() {
		const { AppConfig, actions } = this.props;

		let {
			formTitle,

			string_formStateKey,
			string_formInput,
		} = AppConfig;

		const parseObject = AppConfig[`${string_formStateKey}_parseObject`];

		const stringConfigName = (() => {
			const keys = Object.keys(GENERIC_STRING_KEYS);

			for (let index = 0; index < keys.length; index++) {
				const key = keys[index];

				if (string_formStateKey === GENERIC_STRING_KEYS[key]) {
					return key;
				}
			}
		})();

		actions.setValue({
			isLoadingAction: true,
		});

		try {
			let stringConfig = await new Promise((resolve, reject) => {
				if (parseObject) {
					resolve(parseObject);
				} else {
					let stringConfigQuery = new Parse.Query('StringConfig');

					stringConfigQuery.equalTo('name', stringConfigName);

					stringConfigQuery
						.first()
						.then((data) => {
							if (!data) {
								resolve(
									new Parse.Object('StringConfig', {
										name: stringConfigName,
									})
								);
							} else {
								resolve(data);
							}
						})
						.catch(reject);
				}
			});

			if (!IS_VALID(stringConfig.get('value')) || stringConfig.get('value') !== string_formInput) {
				stringConfig.set('value', string_formInput);
			}

			stringConfig = await stringConfig.save();

			const stateToUpdate = {
				isLoadingAction: false,

				showModal: false,
				[string_formStateKey]: string_formInput,
				[`${string_formStateKey}_parseObject`]: stringConfig,
			};

			actions.setValue(stateToUpdate);

			toast.success('Data has been updated.');

			saveTrail('UPDATE', {
				[formTitle]: string_formInput,
			});
		} catch (error) {
			console.log('saveStringConfig error');
			console.log(error);

			actions.setValue({
				isLoadingAction: false,
			});

			this.getStringConfig();
		}
	}

	renderModalButton() {
		let { AppConfig, actions } = this.props;

		let { formType, isLoadingAction } = AppConfig;

		let buttons = [];

		let button = (name, callback) => (
			<Button bsStyle="primary" onClick={() => callback()} disabled={isLoadingAction}>
				{isLoadingAction ? (
					<span>
						<i className="fa fa-spinner fa-spin" style={{ color: 'white' }}></i>&nbsp;
					</span>
				) : (
					''
				)}
				{name}
			</Button>
		);

		let buttonClose = (
			<Button
				disabled={isLoadingAction}
				onClick={() => {
					if (!isLoadingAction) {
						actions.setValue({
							showModal: false,
						});
					}
				}}
			>
				CLOSE
			</Button>
		);

		switch (formType.toUpperCase()) {
			case 'EVOUCHER_NOTIF':
				buttons.push(button('UPDATE', this.saveEVoucherNotifConfig), buttonClose);
				break;
			case 'SHOWS_NOTIF':
				buttons.push(button('UPDATE', this.saveShowsNotifConfig), buttonClose);
				break;
			case 'MENU':
				buttons.push(button('UPDATE', this.saveMenuConfig), buttonClose);
				break;
			case 'CARD':
				buttons.push(button('UPDATE', this.saveCardConfig), buttonClose);
				break;
			case 'STRING':
				buttons.push(button('UPDATE', this.saveStringConfig), buttonClose);
				break;
			default:
				break;
		}
		return buttons;
	}

	render() {
		const { AppConfig, actions } = this.props;

		const {
			showModal,
			isLoadingAction,

			formType,
			formTitle,

			evoucherNotif_isLoading,
			evoucherNotif_dailyNotifAM_hh,
			evoucherNotif_dailyNotifAM_mm,
			evoucherNotif_dailyNotifPM_hh,
			evoucherNotif_dailyNotifPM_mm,

			showsNotif_isLoading,
			showsNotif_dailyNotif_hh,
			showsNotif_dailyNotif_mm,
			showsNotif_dailyNotif_ss,

			menu_isLoading,
			menu_isTierPointsEnabled,
			menu_isGVEnabled,
			menu_isCalypsoEnabled,
			menu_isRaffleDrawEnabled,
			menu_isInvitationsEnabled,

			card_isLoading,
			card_isQRCodeEnabled,

			string_isLoading,
			string_casinoPromotionsUrl,
			string_lifestyleUrl,
			string_directoryUrl,
			string_shuttleUrl,
			string_nwrHotline,
			string_winfordHotline,
			string_epicMillionsSecretKey,
		} = AppConfig;

		const formContainerProps = {
			actions,

			formType,
		};

		const tdStyle = {
			maxWidth: '100px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		};

		return (
			<div>
				<Panel>
					<Panel.Heading
						style={{
							backgroundColor: '#D1282F',
							color: 'white',
						}}
					>
						<h4>App Config</h4>
					</Panel.Heading>
					<Panel.Body>
						<Table striped bordered hover>
							<thead>
								<tr>
									<th>Config</th>
									<th>Value</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>EVOUCHER_NOTIF</td>
									<td>
										{evoucherNotif_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!evoucherNotif_isLoading && [
											<p>
												Daily AM:
												<br />
												<b>{`${evoucherNotif_dailyNotifAM_hh}:${evoucherNotif_dailyNotifAM_mm}`}</b>
											</p>,
											<p>
												Daily PM:
												<br />
												<b>{`${evoucherNotif_dailyNotifPM_hh}:${evoucherNotif_dailyNotifPM_mm}`}</b>
											</p>,
										]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'EVOUCHER_NOTIF',
														formTitle: 'EVOUCHER_NOTIF',

														evoucherNotif_dailyAM: `${evoucherNotif_dailyNotifAM_hh}:${evoucherNotif_dailyNotifAM_mm}`,
														evoucherNotif_dailyPM: `${evoucherNotif_dailyNotifPM_hh}:${evoucherNotif_dailyNotifPM_mm}`,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>SHOWS_NOTIF</td>
									<td>
										{showsNotif_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!showsNotif_isLoading &&
											`${showsNotif_dailyNotif_hh}h ${showsNotif_dailyNotif_mm}m ${showsNotif_dailyNotif_ss}s`}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'SHOWS_NOTIF',
														formTitle: 'SHOWS_NOTIF',

														showsNotif_form_dailyNotif_hh: showsNotif_dailyNotif_hh,
														showsNotif_form_dailyNotif_mm: showsNotif_dailyNotif_mm,
														showsNotif_form_dailyNotif_ss: showsNotif_dailyNotif_ss,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>MENU</td>
									<td>
										{menu_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!menu_isLoading && [
											<p>
												Tier Points:{' '}
												<span
													style={{
														color: menu_isTierPointsEnabled ? '#008000' : '#ff0000',
													}}
												>
													{menu_isTierPointsEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
											<p>
												Gift Voucher:{' '}
												<span
													style={{
														color: menu_isGVEnabled ? '#008000' : '#ff0000',
													}}
												>
													{menu_isGVEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
											<p>
												Calypso Voucher:{' '}
												<span
													style={{
														color: menu_isCalypsoEnabled ? '#008000' : '#ff0000',
													}}
												>
													{menu_isCalypsoEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
											<p>
												Raffle Draw:{' '}
												<span
													style={{
														color: menu_isRaffleDrawEnabled ? '#008000' : '#ff0000',
													}}
												>
													{menu_isRaffleDrawEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
											<p>
												Invitations:{' '}
												<span
													style={{
														color: menu_isInvitationsEnabled ? '#008000' : '#ff0000',
													}}
												>
													{menu_isInvitationsEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
										]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'MENU',
														formTitle: 'MENU',

														menu_form_isTierPointsEnabled: menu_isTierPointsEnabled,
														menu_form_isGVEnabled: menu_isGVEnabled,
														menu_form_isCalypsoEnabled: menu_isCalypsoEnabled,
														menu_form_isRaffleDrawEnabled: menu_isRaffleDrawEnabled,
														menu_form_isInvitationsEnabled: menu_isInvitationsEnabled,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>CARD</td>
									<td>
										{card_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!card_isLoading && [
											<p>
												QR Code:{' '}
												<span
													style={{
														color: card_isQRCodeEnabled ? '#008000' : '#ff0000',
													}}
												>
													{card_isQRCodeEnabled ? 'En' : 'Dis'}abled
												</span>
											</p>,
										]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'CARD',
														formTitle: 'CARD',

														card_form_isQRCodeEnabled: card_isQRCodeEnabled,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Casino Promotions URL</td>
									<td style={tdStyle}>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_casinoPromotionsUrl || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Casino Promotions URL',

														string_formStateKey: 'string_casinoPromotionsUrl',
														string_formInput: string_casinoPromotionsUrl,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Lifestyle URL</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_lifestyleUrl || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Lifestyle URL',

														string_formStateKey: 'string_lifestyleUrl',
														string_formInput: string_lifestyleUrl,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Directory URL</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_directoryUrl || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Directory URL',

														string_formStateKey: 'string_directoryUrl',
														string_formInput: string_directoryUrl,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Shuttle URL</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_shuttleUrl || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Shuttle URL',

														string_formStateKey: 'string_shuttleUrl',
														string_formInput: string_shuttleUrl,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>NWR Hotline</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_nwrHotline || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'NWR Hotline',

														string_formStateKey: 'string_nwrHotline',
														string_formInput: string_nwrHotline,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Winford Hotline</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_winfordHotline || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Winford Hotline',

														string_formStateKey: 'string_winfordHotline',
														string_formInput: string_winfordHotline,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
								<tr>
									<td>Epic Millions Secret Key</td>
									<td>
										{string_isLoading && <i className="fa fa-spinner fa-spin"></i>}
										{!string_isLoading && [<span>{string_epicMillionsSecretKey || ''}</span>]}
									</td>
									<td>
										<OverlayTrigger placement="top" overlay={<Tooltip>Update</Tooltip>}>
											<i
												className="fa fa-pencil"
												aria-hidden="true"
												onClick={() => {
													actions.setValue({
														showModal: true,
														formType: 'STRING',
														formTitle: 'Epic Millions Secret Key',

														string_formStateKey: 'string_epicMillionsSecretKey',
														string_formInput: string_epicMillionsSecretKey,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								</tr>
							</tbody>
						</Table>
					</Panel.Body>
				</Panel>
				<Modal
					{...{
						bsSize:
							formType === 'MENU' || formType === 'CARD' || formType === 'STRING' ? null : 'sm',
						show: showModal,
						backdrop: 'static',
						onHide: () => {
							if (!isLoadingAction) {
								actions.setValue({ showModal: false });
							}
						},
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>{formTitle}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormContainer {...formContainerProps} />
					</Modal.Body>
					<Modal.Footer>{this.renderModalButton()}</Modal.Footer>
				</Modal>
				<ToastContainer />
			</div>
		);
	}

	componentDidMount() {
		this.getEVoucherNotifConfig();
		this.getShowsNotifConfig();
		this.getMenuConfig();
		this.getCardConfig();
		this.getStringConfig();
	}
}

function mapStateToProps(state) {
	var { accessjson, AppConfig } = state;
	return {
		accessjson,
		AppConfig,
	};
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: (keyValueObj, actioType = SET_APP_CONFIG) =>
			generics.setValue(actioType, keyValueObj),
	};

	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppConfig);



// WEBPACK FOOTER //
// ./components/AppConfig/index.js